import styled, { css } from "styled-components";

function getFilter(type: "white" | "colored" | "black") {
  switch (type) {
    case "white": {
      /* filter: invert(100%) sepia(99%) saturate(0%) hue-rotate(124deg)
        brightness() contrast(100%); */
      return css`
        filter: brightness(0) invert(1);
      `;
    }
    case "colored": {
      return css`
        filter: invert(43%) sepia(65%) saturate(2352%) hue-rotate(167deg)
          brightness(97%) contrast(103%);
      `;
    }
    case "black":
    default: {
      return undefined;
    }
  }
}

export const Image = styled.img<{
  type?: "white" | "colored" | "black";
}>`
  max-width: 100%;
  max-height: 100%;

  ${({ type }) => type !== undefined && getFilter(type)};
`;
